
import Vue, { PropType } from "vue";
import Btn from "@/components/v2/base/Btn.vue";
import DeckWordsList from "@/components/words/DeckWordsList.vue";
import { DeckWord } from "@/types/repetitionWords";
import { DialogCloseType, DialogI } from "@/types/dialog";

const LEAVE_MS = 200;

/**
 * The deck counter's word list as a bottom sheet — phones, and the app's native header counter (the app
 * asks for it with "deckListRequested"). The idle letter hint waits while it is open; the answer field
 * gets its focus back on close.
 */
export default Vue.extend({
  name: "DeckWordsDialog",
  components: { Btn, DeckWordsList },
  props: {
    dialog: {
      type: Object as PropType<DialogI>,
      required: true,
    },
  },
  data() {
    return {
      open: true,
      returnFocusTo: null as HTMLElement | null,
    };
  },
  computed: {
    words(): DeckWord[] {
      return this.$store.getters["wordRepetition/getDeckWords"];
    },
    maxWidth(): number {
      return this.$vuetify.breakpoint.mdAndUp ? 768 : 1272;
    },
  },
  watch: {
    open(isOpen: boolean) {
      if (isOpen) return;
      setTimeout(() => this.dialog.close({ type: DialogCloseType.CLOSED }), LEAVE_MS);
    },
  },
  created() {
    this.$store.commit("wordRepetition/setDeckListOpen", true);
    const active = document.activeElement as HTMLElement | null;
    if (active && /^(INPUT|TEXTAREA)$/.test(active.tagName)) {
      this.returnFocusTo = active;
      active.blur();
    }
  },
  beforeDestroy() {
    this.$store.commit("wordRepetition/setDeckListOpen", false);
    if (this.returnFocusTo?.isConnected) this.returnFocusTo.focus({ preventScroll: true });
  },
});
